import React from 'react';

/**
 * Temporary Error Boundary for debugging white screen
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary] React crash:', error);
    console.error('[ErrorBoundary] Stack trace:', errorInfo.componentStack);
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 40, fontFamily: 'monospace', background: '#fee', color: '#900' }}>
          <h1>React Error Caught</h1>
          <p><strong>Error:</strong> {this.state.error?.toString?.() || 'Unknown'}</p>
          <pre style={{ whiteSpace: 'pre-wrap', background: '#fff', padding: 16, border: '1px solid #fcc' }}>
            {this.state.errorInfo?.componentStack || 'No stack trace'}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
